/* Not loaded on the storefront: the theme loads esp-accessibility.min.js, a copy of this file. Shopify re-minifies .js assets into syntax iOS 13.0-13.3 cannot run, and serves .min.js files as they are. Make changes in esp-accessibility.min.js. */
(() => {
  if (window.espAccessibilityReady) return;
  window.espAccessibilityReady = true;
  const strings = window.espAccessibilityStrings || {};
  const displayed = element => Boolean((element === null || element === void 0 ? void 0 : element.isConnected) && !element.closest('[hidden]') && element.getClientRects().length && getComputedStyle(element).visibility !== 'hidden' && getComputedStyle(element).display !== 'none');
  const visible = element => {
    if (!displayed(element) || element.closest('[inert]')) return false;
    // Collapsed details descendants can retain client rectangles even though
    // native Tab skips them. Only their first direct summary remains available.
    for (let ancestor = element.parentElement; ancestor; ancestor = ancestor.parentElement) {
      var _ancestor$querySelect;
      if (ancestor.tagName === 'DETAILS' && !ancestor.open && !((_ancestor$querySelect = ancestor.querySelector(':scope > summary')) !== null && _ancestor$querySelect !== void 0 && _ancestor$querySelect.contains(element))) return false;
    }
    return true;
  };
  const set = (element, name, value) => {
    if (element.getAttribute(name) !== String(value)) element.setAttribute(name, String(value));
  };
  const items = root => [...root.querySelectorAll('a[href],button,input:not([type="hidden"]),select,textarea,summary,iframe,[tabindex],[contenteditable="true"]')].filter(element => visible(element) && !element.matches(':disabled') && element.tabIndex >= 0 && !element.closest('[aria-hidden="true"]'));
  let active = null,
    lastTrigger = null,
    scheduled = false,
    zoomTrigger = null;
  let filterFocusReveal = null;
  const backgrounds = new Map();
  const legacyGallerySelector = 'main .main-product-gallery product-slider-component.js-slider-main[data-type="main"]';
  const legacySlideSelector = `${legacyGallerySelector} .main-slider > .media-item.tns-item`;
  const inactiveGallerySlides = new Set();
  let legacyImageFocus = null,
    legacyFocusHandoff = null;
  function cancelLegacyFocusHandoff() {
    legacyImageFocus = null;
    legacyFocusHandoff = null;
  }
  function cancelLegacyFocusIntent() {
    var _active;
    cancelLegacyFocusHandoff();
    if (((_active = active) === null || _active === void 0 ? void 0 : _active.kind) === 'zoom' && !document.documentElement.classList.contains('mz-expanded-view-open')) active.legacyOpener = null;
  }
  function legacyImageState(target) {
    var _target$closest;
    const anchor = target === null || target === void 0 || (_target$closest = target.closest) === null || _target$closest === void 0 ? void 0 : _target$closest.call(target, 'a.MagicZoom');
    const root = anchor === null || anchor === void 0 ? void 0 : anchor.closest('main .main-product-gallery');
    const main = root === null || root === void 0 ? void 0 : root.querySelector('product-slider-component.js-slider-main[data-type="main"]');
    const desktop = root === null || root === void 0 ? void 0 : root.querySelector('product-thumbnail[data-type="thumb"]');
    if (!main || !desktop) return null;
    const owner = anchor.closest('product-slider-component,product-thumbnail');
    if (owner !== main && owner !== desktop) return;
    const list = owner.querySelector(owner === main ? '.main-slider' : '.thumbnail-slider');
    const index = [...((list === null || list === void 0 ? void 0 : list.children) || [])].indexOf(anchor.closest('.media-item'));
    if (index < 0) return;
    return {
      anchor,
      root,
      main,
      desktop,
      index,
      width: innerWidth,
      height: innerHeight
    };
  }
  function rememberLegacyImageFocus(target) {
    const previous = legacyImageFocus;
    if (target === document.body && previous && !displayed(previous.anchor) && (legacyFocusHandoff || previous.width !== innerWidth || previous.height !== innerHeight)) return;
    cancelLegacyFocusHandoff();
    if (visible(target) && !target.closest('[aria-hidden="true"]')) legacyImageFocus = legacyImageState(target);
  }
  function queueLegacyFocusHandoff(state, closedViewer = null) {
    legacyImageFocus = state;
    const handoff = legacyFocusHandoff = {
      state,
      closedViewer,
      ready: false
    };
    // Let the vendor's resize layout run first. Later initialization/slide
    // mutations use the existing refresh observer rather than polling.
    requestAnimationFrame(() => requestAnimationFrame(() => {
      if (legacyFocusHandoff !== handoff) return;
      handoff.ready = true;
      schedule();
    }));
  }
  function planLegacyFocusHandoff() {
    var _legacyFocusHandoff, _legacyFocusHandoff2;
    const state = legacyImageFocus;
    if (!state || state.width === innerWidth && state.height === innerHeight) return;
    state.width = innerWidth;
    state.height = innerHeight;
    if (!state.anchor.isConnected || active || candidates().length || document.activeElement !== state.anchor && document.activeElement !== document.body && !((_legacyFocusHandoff = legacyFocusHandoff) !== null && _legacyFocusHandoff !== void 0 && (_legacyFocusHandoff = _legacyFocusHandoff.closedViewer) !== null && _legacyFocusHandoff !== void 0 && _legacyFocusHandoff.contains(document.activeElement))) {
      cancelLegacyFocusHandoff();
      return;
    }
    if (displayed(state.anchor) && !legacyFocusHandoff) return;
    queueLegacyFocusHandoff(state, (_legacyFocusHandoff2 = legacyFocusHandoff) === null || _legacyFocusHandoff2 === void 0 ? void 0 : _legacyFocusHandoff2.closedViewer);
  }
  function restoreLegacyImageFocus() {
    var _handoff$closedViewer, _target$scrollIntoVie, _target;
    const handoff = legacyFocusHandoff;
    if (!(handoff !== null && handoff !== void 0 && handoff.ready)) return;
    const state = handoff.state;
    if (!state.anchor.isConnected || active || candidates().length || !visible(state.root) || document.activeElement !== state.anchor && document.activeElement !== document.body && !((_handoff$closedViewer = handoff.closedViewer) !== null && _handoff$closedViewer !== void 0 && _handoff$closedViewer.contains(document.activeElement))) {
      cancelLegacyFocusHandoff();
      return;
    }
    let target = state.anchor;
    if (!displayed(target)) {
      const owner = displayed(state.main) ? state.main : displayed(state.desktop) ? state.desktop : null;
      if (!owner) return;
      const list = owner.querySelector(owner === state.main ? '.main-slider' : '.thumbnail-slider');
      const slide = list === null || list === void 0 ? void 0 : list.children[state.index];
      target = slide === null || slide === void 0 ? void 0 : slide.querySelector('a.MagicZoom');
      if (!target) {
        cancelLegacyFocusHandoff();
        return;
      }
      if (owner === state.main) {
        var _state$main$getSlide, _state$main$getSlide$;
        const info = (_state$main$getSlide = state.main.getSlide) === null || _state$main$getSlide === void 0 || (_state$main$getSlide$ = _state$main$getSlide.getInfo) === null || _state$main$getSlide$ === void 0 ? void 0 : _state$main$getSlide$.call(_state$main$getSlide);
        if (!info || typeof state.main.goTo !== 'function') return;
        if (info.displayIndex !== state.index + 1) state.main.goTo(state.index);
        syncLegacyGallerySlides();
      }
    }
    if (!visible(target) || target.closest('[aria-hidden="true"]')) return;
    legacyFocusHandoff = null;
    target.focus({
      preventScroll: true
    });
    if (document.activeElement === target) (_target$scrollIntoVie = (_target = target).scrollIntoView) === null || _target$scrollIntoVie === void 0 || _target$scrollIntoVie.call(_target, {
      behavior: 'instant',
      block: 'nearest',
      inline: 'nearest'
    });
  }
  function syncLegacyGallerySlides() {
    const recoverFocus = new Set();
    for (const slide of inactiveGallerySlides) {
      if (!slide.matches(legacySlideSelector) || !slide.isConnected || slide.getAttribute('aria-hidden') !== 'true') {
        slide.inert = false;
        inactiveGallerySlides.delete(slide);
      }
    }
    document.querySelectorAll(legacySlideSelector).forEach(slide => {
      if (slide.getAttribute('aria-hidden') !== 'true') return;
      if (slide.contains(document.activeElement)) recoverFocus.add(slide.closest('product-slider-component'));
      if (!slide.inert) {
        slide.inert = true;
        inactiveGallerySlides.add(slide);
      }
    });
    for (const gallery of recoverFocus) {
      const selectedSlide = [...gallery.querySelectorAll('.main-slider > .media-item.tns-item')].find(slide => slide.getAttribute('aria-hidden') !== 'true' && !slide.inert);
      const target = selectedSlide && items(selectedSlide)[0] || items(gallery).find(element => element.matches('.tns-nav button'));
      target === null || target === void 0 || target.focus({
        preventScroll: true
      });
    }
  }
  function lock(root) {
    let branch = root;
    while ((_branch = branch) !== null && _branch !== void 0 && _branch.parentElement && branch !== document.body) {
      var _branch;
      for (const sibling of branch.parentElement.children) {
        if (sibling === branch || /^(SCRIPT|STYLE|LINK|TEMPLATE)$/.test(sibling.tagName) || sibling.matches('[role="status"],[role="alert"],.esp-announcements')) continue;
        if (!backgrounds.has(sibling)) backgrounds.set(sibling, sibling.inert);
        if (!sibling.inert) sibling.inert = true;
      }
      branch = branch.parentElement;
    }
  }
  function cancelFilterFocusReveal() {
    if (filterFocusReveal) cancelAnimationFrame(filterFocusReveal.frame);
    filterFocusReveal = null;
  }
  function revealNativeFilterFocus() {
    cancelFilterFocusReveal();
    const dialog = active,
      target = document.activeElement;
    if ((dialog === null || dialog === void 0 ? void 0 : dialog.kind) !== 'filters' || target === dialog.root || !dialog.root.contains(target)) return;
    const pending = filterFocusReveal = {
      dialog,
      target,
      frame: null
    };
    pending.frame = requestAnimationFrame(() => {
      pending.frame = requestAnimationFrame(() => {
        if (filterFocusReveal !== pending) return;
        filterFocusReveal = null;
        const root = dialog.root;
        if (active !== dialog || document.activeElement !== target || !visible(root) || !visible(target) || target.closest('[aria-hidden="true"]') || !root.contains(target) || !document.body.classList.contains('filter-toggle') || !window.matchMedia('(max-width: 991px)').matches) return;
        const box = root.getBoundingClientRect(),
          rect = target.getBoundingClientRect();
        let top = Math.max(0, box.top + root.clientTop);
        let bottom = Math.min(innerHeight, box.top + root.clientTop + root.clientHeight);
        const header = document.querySelector('body > header');
        if (displayed(header)) {
          const headerBox = header.getBoundingClientRect();
          if (headerBox.right > rect.left && headerBox.left < rect.right && headerBox.top < top + rect.height && headerBox.bottom > top) top = headerBox.bottom;
        }
        if (bottom <= top || rect.height <= 0) return;
        const inset = bottom - top >= rect.height + 8 ? 4 : 0;
        top += inset;
        bottom -= inset;
        const delta = rect.top < top ? rect.top - top : rect.bottom > bottom ? rect.bottom - bottom : 0;
        if (Math.abs(delta) > 0.5) root.scrollTop = Math.max(0, Math.min(root.scrollHeight - root.clientHeight, root.scrollTop + delta));
      });
    });
  }
  function release(restore = true) {
    if (!active) return;
    cancelFilterFocusReveal();
    const old = active;
    active = null;
    for (const [element, inert] of backgrounds) element.inert = inert;
    backgrounds.clear();
    for (const [name, value] of old.attributes) {
      if (value === null) old.root.removeAttribute(name);else set(old.root, name, value);
    }
    if (restore && old.kind === 'filters') {
      var _old$filterScope;
      if (document.activeElement !== document.body && document.activeElement !== old.opener && !old.root.contains(document.activeElement)) return;
      if (!visible(old.opener)) old.opener = [...(((_old$filterScope = old.filterScope) === null || _old$filterScope === void 0 ? void 0 : _old$filterScope.querySelectorAll('button.btn-filter[data-class-name="filter-toggle"][data-class-rule="add"]')) || [])].find(visible);
    }
    if (restore && old.legacyOpener && !displayed(old.opener) && (document.activeElement === document.body || document.activeElement === old.opener || old.root.contains(document.activeElement))) {
      queueLegacyFocusHandoff(old.legacyOpener, old.root);
      return;
    }
    if (restore && visible(old.opener)) {
      old.opener.focus({
        preventScroll: true
      });
      requestAnimationFrame(() => requestAnimationFrame(() => {
        if (!active && visible(old.opener) && (document.activeElement === document.body || old.root.contains(document.activeElement))) old.opener.focus({
          preventScroll: true
        });
      }));
    }
  }
  function activate(candidate) {
    var _active2;
    if (((_active2 = active) === null || _active2 === void 0 ? void 0 : _active2.root) === candidate.root) {
      lock(active.root);
      return;
    }
    release(false);
    const root = candidate.root;
    const attributes = ['role', 'aria-modal', 'aria-label', 'tabindex'].map(name => [name, root.getAttribute(name)]);
    const opener = candidate.kind === 'zoom' ? zoomTrigger : lastTrigger;
    const legacyOpener = candidate.kind === 'zoom' && visible(opener) ? legacyImageState(opener) : null;
    active = {
      ...candidate,
      opener,
      legacyOpener,
      attributes,
      filterScope: candidate.kind === 'filters' ? root.closest('filter-component') : null
    };
    set(root, 'role', 'dialog');
    set(root, 'aria-modal', 'true');
    set(root, 'tabindex', '-1');
    if (!root.getAttribute('aria-label') && !root.getAttribute('aria-labelledby')) set(root, 'aria-label', candidate.name);
    lock(root);
    if (!root.contains(document.activeElement)) (items(root)[0] || root).focus({
      preventScroll: true
    });
    if (candidate.kind === 'filters') revealNativeFilterFocus();
  }
  function candidates() {
    const found = [];
    const zoom = document.querySelector('.mz-expand');
    if (zoom && document.documentElement.classList.contains('mz-expanded-view-open') && displayed(zoom)) found.push({
      root: zoom,
      kind: 'zoom',
      name: strings.imageViewer || 'Product images',
      close: () => {
        var _window$MagicZoom;
        return (_window$MagicZoom = window.MagicZoom) === null || _window$MagicZoom === void 0 ? void 0 : _window$MagicZoom.close(zoomTrigger);
      }
    });
    const filter = document.querySelector('.sidebar-section-content');
    if (window.matchMedia('(max-width: 991px)').matches && document.body.classList.contains('filter-toggle') && displayed(filter)) found.push({
      root: filter,
      kind: 'filters',
      name: strings.filters || 'Filters',
      close: () => {
        document.body.classList.remove('filter-toggle');
        schedule();
      }
    });
    return found;
  }
  function labelSupportFrame() {
    var _frame$getAttribute;
    const frame = document.querySelector('iframe#chat-widget-iframe');
    if (!frame || (_frame$getAttribute = frame.getAttribute('title')) !== null && _frame$getAttribute !== void 0 && _frame$getAttribute.trim()) return;
    let source;
    try {
      source = new URL(frame.getAttribute('src') || '', document.baseURI);
    } catch {
      return;
    }
    if (source.origin === 'https://widget2.vanchat.app' && source.pathname === '/app/embed') set(frame, 'title', strings.chatSupport || 'Customer support chat');
  }
  function labelImageControls() {
    const viewer = document.querySelector('.mz-expand');
    if (!viewer) return;
    for (const direction of ['prev', 'next']) {
      var _viewer$querySelector;
      const name = (_viewer$querySelector = viewer.querySelector(`.mz-button-${direction}`)) === null || _viewer$querySelector === void 0 ? void 0 : _viewer$querySelector.getAttribute('title');
      const button = viewer.querySelector(`.magic-thumbs-button-${direction}`);
      if (button && name) set(button, 'aria-label', name);
    }
  }
  function repairContentHeadings() {
    const headings = location.pathname.includes('/pages/shipping-policy') ? ['Domestic Shipping Rates and Estimates', 'Shipping to P.O. boxes', 'How to Check Order Status', 'Returns and Refunds'] : location.pathname.includes('/blogs/') ? ['Frequently Asked Questions'] : [];
    if (!headings.length) return;
    document.querySelectorAll('main p').forEach(paragraph => {
      const title = paragraph.textContent.trim().replace(/\s+/g, '');
      if (!headings.some(heading => heading.replace(/\s+/g, '') === title) || !paragraph.querySelector('b,strong')) return;
      const heading = document.createElement('h2');
      const style = getComputedStyle(paragraph);
      heading.className = paragraph.className;
      if (paragraph.id) heading.id = paragraph.id;
      heading.style.cssText = paragraph.style.cssText;
      for (const property of ['font-size', 'font-weight', 'line-height', 'margin-top', 'margin-bottom', 'color']) heading.style.setProperty(property, style.getPropertyValue(property));
      heading.append(...paragraph.childNodes);
      paragraph.replaceWith(heading);
    });
  }
  function refresh() {
    var _window$document;
    scheduled = false;
    if (!((_window$document = window.document) !== null && _window$document !== void 0 && _window$document.body)) return;
    syncLegacyGallerySlides();
    if (active && (!active.root.isConnected || getComputedStyle(active.root).display === 'none' || getComputedStyle(active.root).visibility === 'hidden' || active.kind === 'zoom' && !document.documentElement.classList.contains('mz-expanded-view-open') || active.kind === 'filters' && (!document.body.classList.contains('filter-toggle') || !window.matchMedia('(max-width: 991px)').matches))) release();
    const next = candidates().at(-1);
    if (next) activate(next);else if (active) release();
    labelSupportFrame();
    labelImageControls();
    repairContentHeadings();
    restoreLegacyImageFocus();
  }
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(refresh);
  }
  function focusFinderShortcut(event, trigger) {
    if (!(trigger !== null && trigger !== void 0 && trigger.matches('a#find-tool,a#find-tool-btn')) || !/\/pages\/replacement-filters\/?$/.test(location.pathname) || !trigger.closest('main') || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    const finder = [...document.querySelectorAll('main .section-search-container filter-manuals')].find(visible);
    if (!finder) return;
    const previousFocus = document.activeElement;
    requestAnimationFrame(() => {
      if (document.activeElement !== previousFocus && document.activeElement !== trigger) return;
      const systems = items(finder).filter(element => element.matches('button.sys-btn'));
      const target = systems.find(button => button.getAttribute('aria-pressed') === 'true') || systems.find(button => button.classList.contains('active')) || systems[0];
      target === null || target === void 0 || target.focus({
        preventScroll: true
      });
    });
  }
  document.addEventListener('click', event => {
    var _event$target$closest, _event$target, _active3;
    cancelFilterFocusReveal();
    cancelLegacyFocusIntent();
    const trigger = (_event$target$closest = (_event$target = event.target).closest) === null || _event$target$closest === void 0 ? void 0 : _event$target$closest.call(_event$target, 'button,a[href],summary,[role="button"]');
    focusFinderShortcut(event, trigger);
    if (trigger && !((_active3 = active) !== null && _active3 !== void 0 && _active3.root.contains(trigger))) lastTrigger = trigger;
    if (trigger !== null && trigger !== void 0 && trigger.matches('.MagicZoom')) zoomTrigger = trigger;
    schedule();
  }, true);
  document.addEventListener('keydown', event => {
    var _active4, _event$target$closest2, _event$target2, _active5, _event$target$closest3, _event$target3, _window$MagicZoom2;
    cancelFilterFocusReveal();
    if (legacyFocusHandoff || event.key === 'Tab' || ((_active4 = active) === null || _active4 === void 0 ? void 0 : _active4.kind) === 'zoom' && !document.documentElement.classList.contains('mz-expanded-view-open')) cancelLegacyFocusIntent();
    if (event.key === 'Tab') syncLegacyGallerySlides();
    const trigger = (_event$target$closest2 = (_event$target2 = event.target).closest) === null || _event$target$closest2 === void 0 ? void 0 : _event$target$closest2.call(_event$target2, 'button,a[href],summary,[role="button"]');
    if ((event.key === 'Enter' || event.key === ' ') && trigger && !((_active5 = active) !== null && _active5 !== void 0 && _active5.root.contains(trigger))) lastTrigger = trigger;
    const image = (_event$target$closest3 = (_event$target3 = event.target).closest) === null || _event$target$closest3 === void 0 ? void 0 : _event$target$closest3.call(_event$target3, 'a.MagicZoom');
    if (image && (event.key === 'Enter' || event.key === ' ') && typeof ((_window$MagicZoom2 = window.MagicZoom) === null || _window$MagicZoom2 === void 0 ? void 0 : _window$MagicZoom2.expand) === 'function') {
      event.preventDefault();
      event.stopPropagation();
      zoomTrigger = image;
      lastTrigger = image;
      window.MagicZoom.expand(image);
      schedule();
      return;
    }
    if (!active || !active.root.isConnected) return;
    if (event.key === 'Escape') {
      var _event$target$closest4, _event$target4;
      if (event.defaultPrevented) return;
      const detail = (_event$target$closest4 = (_event$target4 = event.target).closest) === null || _event$target$closest4 === void 0 ? void 0 : _event$target$closest4.call(_event$target4, 'details[open]');
      if (detail && active.root.contains(detail)) {
        var _detail$querySelector;
        event.preventDefault();
        event.stopPropagation();
        detail.open = false;
        (_detail$querySelector = detail.querySelector('summary')) === null || _detail$querySelector === void 0 || _detail$querySelector.focus();
        return;
      }
      event.preventDefault();
      event.stopImmediatePropagation();
      active.close();
      schedule();
    } else if (event.key === 'Tab') {
      const controls = items(active.root),
        first = controls[0],
        last = controls.at(-1);
      if (!first) {
        event.preventDefault();
        active.root.focus();
      } else if (!active.root.contains(document.activeElement) || document.activeElement === active.root) {
        event.preventDefault();
        (event.shiftKey ? last : first).focus();
      } else if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  }, true);
  document.addEventListener('focus', event => {
    rememberLegacyImageFocus(event.target);
  }, true);
  document.addEventListener('focusin', event => {
    if (active && visible(active.root) && !active.root.contains(event.target)) (items(active.root)[0] || active.root).focus({
      preventScroll: true
    });
  });
  document.addEventListener('focusout', event => {
    const state = legacyImageFocus;
    if (event.target !== (state === null || state === void 0 ? void 0 : state.anchor)) return;
    if (event.relatedTarget && event.relatedTarget !== document.body || displayed(state.anchor) || !legacyFocusHandoff && state.width === innerWidth && state.height === innerHeight) cancelLegacyFocusHandoff();
  }, true);
  document.addEventListener('pointerdown', () => {
    cancelFilterFocusReveal();
    cancelLegacyFocusIntent();
  }, true);
  for (const type of ['wheel', 'touchstart']) document.addEventListener(type, cancelFilterFocusReveal, {
    capture: true,
    passive: true
  });
  new MutationObserver(schedule).observe(document.body, {
    subtree: true,
    childList: true,
    characterData: true,
    attributes: true,
    attributeFilter: ['class', 'style', 'aria-hidden', 'aria-label', 'aria-activedescendant', 'src', 'title']
  });
  new MutationObserver(schedule).observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['class']
  });
  window.addEventListener('resize', () => {
    planLegacyFocusHandoff();
    schedule();
    revealNativeFilterFocus();
  });
  window.addEventListener('blur', cancelFilterFocusReveal);
  window.addEventListener('blur', cancelLegacyFocusIntent);
  document.addEventListener('transitionend', event => {
    var _event$target$matches, _event$target6;
    if ((_event$target$matches = (_event$target6 = event.target).matches) !== null && _event$target$matches !== void 0 && _event$target$matches.call(_event$target6, '.sidebar-section-content')) schedule();
  }, true);
  document.addEventListener('shopify:section:load', schedule);
  refresh();
})();
